import React from 'react'



const ContactDevloper = () => {
  return (
    <div className="pt-6">
        <h3 className="font-Bree text-white">Made by CLBS LABS</h3>
    </div>
  )
}

export default ContactDevloper